import { IPageTitle } from '@models/IPageTitle';
import SiteEnum from '@models/enums/SiteEnum';
import SharedPageTitle from '@molecules/PageTitle/PageTitle';

const PageTitle = (props: IPageTitle) => (
  <SharedPageTitle {...props} site={SiteEnum.B2B} />
);

export default PageTitle;
